const updateFavoriteButton = (data) => {
  document.querySelectorAll('.add-favorite-product-js').forEach((button) => {
    console.log(button);
    if (data !== undefined && data.id !== undefined) {
      button.setAttribute('data-favorite-id', data.id);
    } else {
      button.removeAttribute('data-favorite-id');
    }
  })
};

document.addEventListener('DOMContentLoaded', () => {
  const sls = [];

  function watchSliders(query) {
    const sliders = Array.from(document.querySelectorAll('.detail-carousel-js'));
    if (query.matches) {
      sliders.forEach((slider) => {
        const sl = tns({
          container: slider,
          items: 3,
          slideBy: 1,
          autoplay: true,
          gutter: 40,
          fixedWidth: 270,
					nav: true,
					navPosition: 'bottom',
					controls: false,
          autoplayTimeout: 10000,
        });
        sls.push(sl);
      });
    } else if (sls !== undefined) {
      sls.forEach((slider, index) => {
        slider.destroy();
        delete sls[index];
      });
    }
  }

  if (document.querySelector('.detail-carousel-js')) {
    const query = window.matchMedia('(max-width: 1240px)');
    query.addListener(watchSliders);
    watchSliders(query);
  }


  let tabs = document.querySelectorAll('.table-product-tab')
  if (tabs) {
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        document.querySelectorAll(`.table-product-tab`).forEach((element) => {
          element.classList.add('tab-inactive');
        });
        e.target.classList.remove('tab-inactive');

        document.querySelectorAll(`.table-product-register-box`).forEach((element) => {
          element.classList.add('hidden');
        });
        let tabContainer = document.querySelector(`.table-product-register-box[data-tab-id="${e.target.dataset.tabId}"]`)
        tabContainer.classList.remove('hidden');
      });
    })
  }

  if (document.querySelector('.add-favorite-product-js') !== null) {
    document.querySelectorAll('.add-favorite-product-js').forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const element = e.target;
        const sfId = element.dataset.productSfid;
        const favoriteId = element.dataset.favoriteId;
        const productType = element.dataset.productType || 'product_group';

        let title = document.querySelector('.product-title');
        if (favoriteId === undefined) {
          if (typeof datalayer !== 'undefined') {
            dataLayer.push({
              gaCategory: 'Formulieren',
              gaAction: 'AddFavorite',
              gaLabel: title !== undefined && title !== null ? title.innerText : '',
              event: 'gaEvent'
            });
          }

          reservationsApi.addFavoriteProduct(sfId, productType, updateFavoriteButton);
        } else {
          if (typeof datalayer !== 'undefined') {
            dataLayer.push({
              gaCategory: 'Formulieren',
              gaAction: 'RemoveFavorite',
              gaLabel: title !== undefined && title !== null ? title.innerText : '',
              event: 'gaEvent'
            });
          }
          reservationsApi.deleteFavoriteProduct(favoriteId, updateFavoriteButton);
        }
      });
    });
  }

  if (document.querySelector('.add-favorite-login-first-js') !== null) {
    document.querySelectorAll('.add-favorite-login-first-js').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.add-favorite-login-first').style.display = 'block';
        document.querySelector('.btn--product-save').style.display = 'block';
        document.body.classList.add('login-first');
      });
    })
  }

  if (document.querySelector('.add-favorite-login-first__btn-js') !== null) {
    document.querySelector('.add-favorite-login-first__btn-js').addEventListener('click', (e) => {
      e.preventDefault();
      const link = e.target.href;
      const email = document.querySelector('.add-favorite-login-first__input-js').value;
      window.location.replace(`${link}?email=${email}`);
    });
  }

  if (document.querySelector('.product-detail-city-js') !== null) {
    const cityCheckboxes = Array.from(document.querySelectorAll('.product-detail-city-js'));
    const cityRows = Array.from(document.querySelectorAll('.filter-product-container .row-product-register-js'));
    cityCheckboxes.forEach((cityCheckbox) => {
      cityCheckbox.addEventListener('change', () => {
        const checkedCities = [];
        cityCheckboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            checkedCities.push(checkbox.value);
          }
        });

        cityRows.forEach((row) => {
          if (checkedCities.length > 0) {
            if (checkedCities.indexOf(row.dataset.city) !== -1) {
              row.classList.remove('hidden');
            } else {
              row.classList.add('hidden');
            }
          } else {
            row.classList.remove('hidden');
          }
        });
      });
    });

    document.querySelector('.toggle-city-filter-js').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.city-filter-list').classList.toggle('open');
      e.target.parentElement.classList.toggle('open');
    });

    document.querySelector('.reset-city-filter-js').addEventListener('click', (e) => {
      e.preventDefault();
      cityRows.forEach((row) => {
        row.classList.remove('hidden');
      });

      cityCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    });
  }
});
